/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-constant-condition */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import Image from "next/image";
import assest from "@/json/assest";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import moment from "moment";
import NoDataFound from "../NodataFound/Nodatafound";

const DashboardTableTxt = styled(Box)`
  /* .MuiTableCell-head {
    background-color: #7695A1 !important;
    color: #fff;
    padding:16px 24px;
}
table{
    button{
        padding:0;
        min-width: auto;
        svg{
            color:#828282;
        }
    }
}
.tableProfile{
    display:flex;
    align-items: center;
    img{
        border-radius:50%;
        margin: 0 8px 0 0;
    }
} */
`;

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(name: string, service: any, date: any, location: any) {
  return { name, service, date, location };
}

const rows = [
  createData("Jon Doe", "Plumber", "09 Dec 2022", "Abuja, Nigeria"),
  createData("Micheal James", "Electrician", "09 Dec 2022", "Abuja, Nigeria"),
  createData("Tom Doe", "Plumber", "09 Dec 2022", "Abuja, Nigeria"),
  createData("Micheal James", "Electrician", "09 Dec 2022", "Abuja, Nigeria"),
  createData("Jon Doe", "Plumber", "09 Dec 2022", "Abuja, Nigeria"),
  createData("Micheal James", "Electrician", "09 Dec 2022", "Abuja, Nigeria"),
  createData("Tom Doe", "Plumber", "09 Dec 2022", "Abuja, Nigeria"),
];

export default function DashboardTable(Data) {
  //console.log(Data, "Datadddddddddddd");

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <DashboardTableTxt>
      <Box className="cmnTable">
        <TableContainer component={Paper}>
          {Data?.Data?.data?.length > 0 ? 
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Client</StyledTableCell>
                <StyledTableCell>Service Provider</StyledTableCell>
                <StyledTableCell>Service Category</StyledTableCell>
                <StyledTableCell>Project Date</StyledTableCell>
                <StyledTableCell> Project Status</StyledTableCell>
                <StyledTableCell>Location</StyledTableCell>
                {/* <StyledTableCell align="center" width={10}>
                  Action
                </StyledTableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {Data?.Data?.data.map((row) => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell component="th" scope="row">
                    <Box className="tableProfile">
                      {/* <Image
                        src={assest.tableProfile}
                        width={24}
                        height={24}
                        alt=""
                      /> */}
                     
                      {row.client_details?.full_name}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Box className="tableProfile">
                      {/* <Image
                        src={assest.tableProfile}
                        width={24}
                        height={24}
                        alt=""
                      /> */}
                      {row?.provider_details?.full_name}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell>
                    {
                      row?.task_service_details?.service_category_details
                        ?.service_name
                    }
                  </StyledTableCell>

                  <StyledTableCell>
                    {" "}
                    {moment(row?.createdAt).format("MMM Do YYYY")}{" "}
                  </StyledTableCell>
                  <StyledTableCell>
                    <button className={row?.task_status ==="Requested" ? "pendingButtons" : row?.task_status ==="Active" ? "ActiveButtons": row?.task_status ==="Completed" ? "ActiveButtons": "cancelButtons"}>
                      {row?.task_status}
                    </button>
                  </StyledTableCell>
                  <StyledTableCell>
                  {row.task_service_details?.city}, {row.task_service_details?.state} 
                  </StyledTableCell>
                  {/* <StyledTableCell align="center">
                    <Button
                      aria-expanded={open ? "true" : undefined}
                      onClick={handleClick}
                    >
                      <MoreVertIcon />
                    </Button>
                  </StyledTableCell> */}

                  {/* <Menu
                    id="demo-positioned-menu"
                    aria-labelledby="demo-positioned-button"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                  >
                    <MenuItem onClick={handleClose}>View Detail</MenuItem>
                    <MenuItem onClick={handleClose}>Suspend</MenuItem>
                  </Menu> */}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
          : <div className="center">
          <NoDataFound />
        </div>
                }
        </TableContainer>
      </Box>
    </DashboardTableTxt>
  );
}
